import React from 'react'
import EcoSystem from '../components/EcoSystem'
import RecruitCom from '../components/RecruitCom'
import SEO from '../components/SEO'

const Recruitment = () => {
  return (
    <div>
      <SEO
        title="Recruitment Outsourcing"
        description="Outsource recruiting, screening, and candidate engagement to Teamup Consultants for faster, scalable hiring support."
        canonical="https://teamupconsultants.com/recruitment"
        keywords="recruitment outsourcing, staffing solutions, hiring support, candidate sourcing"
        url="https://teamupconsultants.com/recruitment"
      />
      <RecruitCom/>
      <EcoSystem/>
    </div>
  )
}

export default Recruitment
